import * as Accordion from '@radix-ui/react-accordion';
import { colourClasses, getTitleIconAndColour } from 'src/components/utils';
import { useSelection } from 'src/context';

export const AccordionView = () => {
    const { selectedContent } = useSelection();

    return (
        <Accordion.Root type="multiple">
            {selectedContent.map(({ section, subsections }, sectionIndex) => {
                return (
                    <Accordion.Item key={section} value={section}>
                        <div className="border-medium-grey border-b">
                            <Accordion.Trigger
                                className={`accordion-trigger flex w-full items-center p-0 ${colourClasses(sectionIndex, 'section')}`}
                            >
                                <img
                                    src={`/assets/images/graphics-and-icons-${getTitleIconAndColour(sectionIndex)?.icon}.svg`}
                                    className="mx-2 w-8"
                                />
                                <h3>{section}</h3>
                            </Accordion.Trigger>

                            <Accordion.Content>
                                {subsections.map(({ subsection, questions }) => (
                                    <div key={subsection} className="mb-4 ml-2">
                                        <h3 className="my-1">{subsection}</h3>
                                        <div>
                                            {questions.map(({ question }) => (
                                                <p key={question} className="py-0.5 text-sm">
                                                    {question}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </Accordion.Content>
                        </div>
                    </Accordion.Item>
                );
            })}
        </Accordion.Root>
    );
};
